import type { SaveContactRequest } from "../api/types";

/**
 * Body del salvataggio in talent pool. Il `search_id` compare **solo** quando
 * il salvataggio parte dalla lista della ricerca attiva: il valore arriva
 * sempre dall'oggetto freelancer consegnato dall'envelope di ricerca (prop
 * per-origine), mai da uno stato condiviso — `HeartButton` e `SheetSaveButton`
 * servono anche il tab pool, che non passa nulla.
 *
 * Sibling di `buildPatchPayload`: il body dell'API non si costruisce inline.
 */
export const buildSaveContactRequest = (
  freelancerProfileId: string,
  searchId?: string,
): SaveContactRequest => ({
  freelancer_profile_id: freelancerProfileId,
  ...(searchId ? { search_id: searchId } : {}),
});
